import { render, staticRenderFns } from "./auxiliarymaterial.vue?vue&type=template&id=223c4f7d"
import script from "./auxiliarymaterial.vue?vue&type=script&lang=js"
export * from "./auxiliarymaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports